// BACKEND
let STAGE = "dev"
const DEV_REST_API_URL = "https://earkc2f9fb.execute-api.us-east-1.amazonaws.com/api/"
const LOCAL_REST_API_URL = "http://127.0.0.1:8000"
export const REST_API_URL = STAGE === "dev" ? DEV_REST_API_URL : (STAGE === "local" ? LOCAL_REST_API_URL : LOCAL_REST_API_URL)

// APP
export const TOKEN_KEY = "user_token"